var packageName = "@atlassian/switcher";
var packageVersion = "0.0.0-development";
export default {
  packageName: packageName,
  packageVersion: packageVersion
};